import { LoadingSpinner } from '@web_opxp/components';
import * as React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from '../language';
import Alert from './components/common/Alert';
import NNLogo from './components/common/NNLogo';
import CountriesSelectView from './components/CountriesSelectView';
import LegalsContent from './components/LegalsContentView';
import './legals.scss';
import * as Selectors from './store/selectors';
import { LegalsActions } from './store/slice';
import { EArticleAlias, ELegalsViews, IArticle } from './types';

export interface ILegalsProps {
  type: EArticleAlias;
  className?: string;
  height?: number;
  ready: boolean;
  articles: IArticle[];
  view: ELegalsViews;
  error: string;
  onReset: () => void;
  onInit: () => void;
}

export const Legals: React.FC<ILegalsProps> = ({
  ready,
  articles,
  view,
  error,
  type,
  className,
  height = 636,
  onReset,
  onInit,
}) => {
  const { language, t } = useTranslation();

  // Cleanup effect to reset legals state on unmount
  React.useEffect(() => {
    if (!ready) {
      onInit();
    }
    return () => {
      onReset();
    };
  }, []);

  if (!ready || !language) {
    return <LoadingSpinner />;
  }

  const errorWidget = error ? <Alert>{t(error)}</Alert> : null;
  const viewWrapper = (view: ELegalsViews) => {
    switch (view) {
      case ELegalsViews.SelectCountry:
        return <CountriesSelectView type={type} />;
      case ELegalsViews.Articles:
        return <LegalsContent articles={articles} />;
    }
  };
  return (
    <div className="legals-container container" style={{ maxHeight: height }}>
      <div className="text-center">
        <NNLogo />
      </div>
      {errorWidget}
      <div className={className}>{viewWrapper(view)}</div>
    </div>
  );
};

export const mapStateToProps = (state: Selectors.IState) => {
  const ready = Selectors.isAppReady(state);
  const articles = Selectors.getArticles(state);
  const view = Selectors.getView(state);
  const error = Selectors.getError(state);
  return { ready, articles, view, error };
};

export const mapDispatchToProps = {
  onInit: LegalsActions.legalsInit,
  onReset: LegalsActions.legalsReset,
};

export default connect(mapStateToProps, mapDispatchToProps)(Legals);
